module.exports = __webpack_public_path__ + "img/level1_mining_tool-2.8c9cc2f0.png";